import { camelCase, startCase, upperFirst } from 'lodash';

import { observeTrackAndLogOnStore } from '@/utils/vuex-common/observeTrackAndLog';

export interface TrackAndLogEntry {
    subjectName: string;
    action: string;
    mutationNames?: { start?: string, finish?: string, fail?: string };
}

export interface TrackAndLogConfig {
    module: string;
    entries: TrackAndLogEntry[];
}

const actionVerbs: Record<string, string> = {
    get: 'Loading',
    load: 'Loading',
    create: 'Creating',
    update: 'Updating',
    delete: 'Deleting',
    patch: 'Patching',
};

export function observeTrackAndLogPerModule(
    app: any,
    config: TrackAndLogConfig,
    // Observes the Pinia store's same-named start/finish/fail actions.
    store: { $onAction: (cb: (context: { name: string, args: any[] }) => void) => void },
) {
    const pascalCase = (input: string): string => upperFirst(camelCase(input));
    config.entries.forEach((entry) => {
        let mutationNames = entry.mutationNames;
        if (!mutationNames) {
            const actionVerb = actionVerbs[entry.action.toLowerCase()] || pascalCase(entry.action);
            const subjectName = pascalCase(entry.subjectName);
            mutationNames = {
                start: `start${actionVerb}${subjectName}`,
                finish: `finish${actionVerb}${subjectName}`,
                fail: `fail${actionVerb}${subjectName}`,
            };
        }
        const text = {
            module: config.module,
            title: startCase(entry.subjectName),
            action: startCase(entry.action),
        };
        observeTrackAndLogOnStore(app, store, mutationNames, text);
    });
}
